/**
 * Right-aligned, tabular, monospace: every number this plane prints is meant
 * to be compared down a column, and proportional digits or a ragged right
 * edge break that at a glance.
 */

import type { ReactNode } from 'react';

export function Figure(props: { children: ReactNode; title?: string }): ReactNode {
  return (
    <span className="inline-block font-mono text-right tabular-nums" title={props.title}>
      {props.children}
    </span>
  );
}
